import { AnagraficaF } from "./AnagraficaF";
import { AnagraficaR } from "./AnagraficaR";
import { AnagraficaSP } from "./AnagraficaSP";

export class InitPagamento {

    tipoPagamento: 'CC' | 'BO' | 'CANTINA' | 'CANTINASC' | 'ZERO' | 'WINESHOPSC';
    fakeSite: boolean;
    isCodiceFormMasterPresente: boolean;
    iscc: boolean;
    isStripeCantina: boolean;

    lang: string;
    idUtente: number;
    fattura: 0 | 1;

    noteordine: string;

    anagraficaF: AnagraficaF;
    anagraficaR: AnagraficaR;
    anagraficaSP: AnagraficaSP;

    puntiTimer: number;
    wineCoinsDintorni: number;

    buonousato: boolean | null;
    listaCodiciScontoCarrello: Array<any>;

    constructor(
        tipoPagamento: 'CC' | 'BO' | 'CANTINA' | 'CANTINASC' | 'ZERO' | 'WINESHOPSC',
        fakeSite: boolean,
        iscc: boolean,
        isStripeCantina: boolean,
        isCodiceFormMasterPresente: boolean,
        lang: string,
        idUtente: number,
        fattura: 0 | 1,
        noteordine: string,
        anagraficaF: AnagraficaF,
        anagraficaR: AnagraficaR,
        anagraficaSP: AnagraficaSP,
        puntiTimer: number,
        wineCoinsDintorni: number,
        buonousato: boolean | null,
        listaCodiciScontoCarrello: Array<any>
    ) {
        this.tipoPagamento = tipoPagamento;
        this.fakeSite = fakeSite;
        this.iscc = iscc;
        this.isStripeCantina = isStripeCantina;
        this.isCodiceFormMasterPresente = isCodiceFormMasterPresente;
        this.lang = lang;
        this.idUtente = idUtente;
        this.fattura = fattura;
        this.noteordine = noteordine;
        this.anagraficaF = anagraficaF;
        this.anagraficaR = anagraficaR;
        this.anagraficaSP = anagraficaSP;
        this.puntiTimer = puntiTimer;
        this.wineCoinsDintorni = wineCoinsDintorni;
        this.buonousato = buonousato;
        this.listaCodiciScontoCarrello = listaCodiciScontoCarrello;
    }

}